// @ts-nocheck

import React from 'react';
import styled from 'styled-components';

import theme from '../../styled-components/dark';

const Wrapper = styled.div`
  position: relative;
  width: 1.6em;
  height: 1.6em;
  display: flex;
  align-items: center;
  justify-content: center;

  transition: all 100ms ease-in-out;

  background-color: ${({ $toggled }) =>
    $toggled ? theme.HelperButton.toggled.backgroundColor : theme.HelperButton.default.backgroundColor};
  border-radius: 50%;

  user-select: none;
  -webkit-tap-highlight: transparent;
  cursor: pointer;

  &:active {
    transform: scale(0.9);
  }
`;

const Inner = styled.span`
  color: ${theme.HelperButton.default.color};
  font-weight: normal;
`;

type HelperButtonProps = {
  toggled: boolean;
  onToggle: (toggled: boolean) => void;
  symbol?: string;
  className?: string;
};

const HelperButton = ({ toggled, onToggle = () => {}, symbol = '?', className = '' }: HelperButtonProps) => {
  return (
    <Wrapper className={className} onClick={onToggle} $toggled={toggled}>
      <Inner>{symbol}</Inner>
    </Wrapper>
  );
};

export default HelperButton;
